// App token stored in memory for Bearer auth to time-clocking-api.
// Not persisted — re-obtained via SSO on each session.
let appToken: string | null = null;

export const getToken = () => appToken;

export const setToken = (token: string) => {
  appToken = token;
};

export const clearTokens = () => {
  appToken = null;
  localStorage.removeItem('__DMS_app_refreshToken');
  localStorage.removeItem('__DMS_app_roleToken');
};
